<template>
  <div id="app">
    <main-head></main-head>
    <main-menu></main-menu>
    <router-view/>
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainFooter from './components/MainFooter.vue';
import MainHead from './components/MainHead.vue';
import MainMenu from './components/MainMenu.vue';
export default {
  name: 'App',
  components: { MainHead, MainMenu, MainFooter }
}
</script>


<style>
#app, html {
  background-color: #fdf4e3;
}

@font-face {
	font-family: 'montserrat';
  src: url(assets/montserrat/montserrat.ttf);
}

body {
	font-family: 'montserrat';
	font-size: 100%;
	color: #000;
	margin: 0em;
	padding: 0em;
	text-decoration: none;
}

.wrapper {
	background-image: url(assets/divider_horizontal.png);
	background-repeat: repeat-x;
	height: 1em;
	vertical-align: top;
}

</style>
<!--[if gte IE 5]>
  <style>
  @font-face {
  font-family: 'montserrat';
  src: url();
  }
  </style>
<![endif]-->
